import type { LinkItem } from './types';

/*
 * Page copy for the /terms index. Its links come from Payload: editors tick
 * "Show on Terms & Conditions page" on a legal page (see `lib/terms-index.ts`).
 */

export interface TermsGroup {
  title: string;
  links: LinkItem[];
}

export const termsContent = {
  title: 'Terms & Conditions',
  lastUpdated: '8 January 2026',
  intro: [
    'The hyperlinks below provide information on the terms and conditions that apply to the use of our website, mobile app, products and services.',
    'By downloading our mobile app and using our products and services, you agree to the terms and conditions below.',
  ],
};
